/*
Copyright 2022 Alexandra Instituttet

Der er givet en begrænset licens af denne software til GEO. Licensen
giver dem ret til at benytte, videreudvikle og fejlrette udelukkende
med henblik på brug i GeoAtlasStudy web-applikationen.
*/
import {WColor} from 'wfundament';

/*
 "Color": "#73A000",
 "Id": "7000",
 "LongName": "100_Postglacial_toerv",
 "Name": "Postglacial tørv",
 "SortOrder": "1"
 */

class VoxelTransferElement {
  constructor(colorHex, id, longName, name, sortOrder) {
    this.colorHex_ = colorHex;
    let tmp = WColor.hexToRgb(this.colorHex_);
    this.color_ = WColor.RgbToVec4(tmp);
    this.id_ = id;
    this.sortOrder = sortOrder;
    this.name_ = name;
    this.longName_ = longName;
  }
}

class VoxelTransferFunction {
  constructor() {
    this.transferFunctionColors_ = new Float32Array(256 * 4);
    this.transferMasks_ = [];
    this.voxelTransferElements_ = [];
    this.voxelNames_ = [];
  }

  async loadVoxelTransfer(fileName) {
    const response = await fetch(fileName);
    this.voxelTransferJson_ = await response.json();
    this.initialize();
  }

  getVoxelName(index) {
    if (index < 0 || index >= 256) {
      return "None";
    }

    return this.voxelNames_[index];
  }

  initialize() {
    if (this.voxelTransferJson_ === undefined) {
      return;
    }

    // create the transfer function data
    for (let i = 0; i < 256; i++) {
      this.transferFunctionColors_[i * 4] = Math.random(); // 1.0;
      this.transferFunctionColors_[i * 4 + 1] = Math.random(); //1.0;
      this.transferFunctionColors_[i * 4 + 2] = Math.random(); //1.0;
      this.transferFunctionColors_[i * 4 + 3] = 1.0;
      this.transferMasks_.push(1.0);
      this.voxelNames_.push("None");
    }

    for (let i = 0; i < this.voxelTransferJson_.MapRoot.MapLegend.length; i++) {
      let mapElm = this.voxelTransferJson_.MapRoot.MapLegend[i];
      let id = parseInt(mapElm.LongName.split("_")[0]) / 100;
      var voxElement = new VoxelTransferElement(
        mapElm.Color,
        id,
        mapElm.LongName,
        mapElm.Name,
        mapElm.sortOrder
      );
      this.voxelTransferElements_.push(voxElement);

      // update the color
      if (voxElement.id_ >= 0 && voxElement.id_ < 256) {
        this.transferFunctionColors_[voxElement.id_ * 4] = voxElement.color_[0];
        this.transferFunctionColors_[voxElement.id_ * 4 + 1] =
          voxElement.color_[1];
        this.transferFunctionColors_[voxElement.id_ * 4 + 2] =
          voxElement.color_[2];
        this.transferFunctionColors_[voxElement.id_ * 4 + 3] =
          voxElement.color_[3];

        this.voxelNames_[voxElement.id_] = voxElement.name_;
      }
    }
  }
}

export { VoxelTransferFunction };
